var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9995 11.5033V18.4663H15.9895V11.9693C15.9895 10.3373 15.4635 9.37928 13.9895 9.37928C12.8635 9.37928 12.4135 9.97329 12.1185 10.6993C12.0105 10.9593 11.9835 11.3203 11.9835 11.6843V18.4673H7.9725C7.9725 18.4673 8.0275 7.58729 7.9725 6.44729H11.9825V8.04429L11.9565 8.08429H11.9825V8.04429C12.5245 7.21829 13.1465 6.41229 15.3105 6.41229C17.9905 6.41229 19.9995 7.77129 19.9995 11.5033ZM5.3945 2.56529C5.3945 3.73129 4.5105 4.66529 3.0905 4.66529H3.0635C1.6975 4.66529 0.8125 3.73129 0.8125 2.56529C0.8125 1.37329 1.7235 0.467285 3.1175 0.467285C4.5105 0.467285 5.3675 1.37329 5.3945 2.56529ZM0.9915 6.47829H5.0015V18.4663H0.9915V6.47829Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.31274bb5a3c1843345fdda0d7b0a2ac5.svg";
export { ForwardRef as ReactComponent };